<template>
  <label
  v-no-select
  class="v-radio-input cursor-pointer"
  :class='{
    disabled: disable
  }'
  >
    <span
      class="v-radio cursor-pointer"
      @click.stop.prevent="select"
      v-no-select
    >
      <input
        type="radio"
        v-model="model"
        :value="val"
        :disabled="disable"
        @click.stop
        @change="__change">
      <div></div>
    </span>
    <span class="v-label" v-html="label"></span>
  </label>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      default: ''
      // required: true
    },
    val: {
      required: true
    },
    disable: Boolean
  },
  watch: {
    disable: function (disabled) {
      if (disabled && this.model === this.val) {
        this.model = ''
      }
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        if (value !== this.value) {
          this.$emit('input', value)
        }
      }
    }
  },
  methods: {
    select () {
      if (!this.disable) {
        this.model = this.val
      }
    },
    __change (e) {
      console.log('radio change', e)
      // this.model = this.val
      this.$emit('input', this.val)
    }
  }
}
</script>
<style>
.v-radio-input {
  user-select: none;
  cursor: pointer;
  display: inline-block;
}

.v-radio {
  display: inline-block;
  height: 22px;
  width: 22px;
  vertical-align: middle;
}
.v-radio input {
  display: none !important;
}
.v-radio input + div {
  position: relative;
}
.v-radio input + div:before,
.v-radio input + div:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  transition: 0.3s ease;
}
.v-radio input + div:before {
  width: 22px;
  height: 22px;
  border: 2px solid #bdbdbd;
}
.v-radio input + div:after {
  -webkit-transform: scale(0);
          transform: scale(0);
  margin: 6px;
  width: 10px;
  height: 10px;
}
.v-radio input:checked + div:before {
  border: 2px solid #027BE3;
}
.v-radio input:checked + div:after {
  background: #027BE3;
  -webkit-transform: scale(1.02);
          transform: scale(1.02);
}
.v-radio.primary input:checked + div:before {
  border-color: #027BE3;
}
.v-radio.primary input:checked + div:after {
  background: #027BE3;
}
.v-radio.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.v-label {
  padding-left: 5px;
}
</style>
